import { jsx as _jsx } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { GoogleMap, Marker, withGoogleMap } from "react-google-maps";
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const MapComponent = withGoogleMap((props) => (
// @ts-expect-error - TS2769 - No overload matches this call.
_jsx(GoogleMap, { defaultCenter: { lat: props.lat, lng: props.lng }, defaultZoom: 16, onZoomChanged: props.onZoomChanged, ref: props.onMapMounted, zoom: props.zoom, children: _jsx(Marker, { position: { lat: props.lat, lng: props.lng } }) })));
class AvisoGoogleMap extends PureComponent {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        this.state = {
            zoom: 16,
        };
    }
    render() {
        const props = Object.assign(Object.assign({}, this.props), { lat: this.props.lat, lng: this.props.lng, zoom: this.state.zoom });
        // @ts-expect-error - TS2739 - Type '{ lat: number; lng: number; zoom: any; }' is missing the following properties from type 'Readonly<WithGoogleMapProps>': containerElement, mapElement
        return _jsx(MapComponent, Object.assign({}, props));
    }
}
export default AvisoGoogleMap;
